export default "__VITE_ASSET__CeUaesOM__"